import { httpClient, httpReservation } from 'shared/services/http/httpClient';
import {
  particularTravelBuilder,
  ParticularTravelsFiltersFormType,
  ParticularTravelsModel,
  ParticularTravelStatus,
} from '../models/particularTravelsModel';
import environment from 'environment/environment';

export const particularTravelService = () => {
  const getAll = async (
    page: number | null,
    page_size: number | null,
    sort: string | null,
    dir: string | null,
    filters: ParticularTravelsFiltersFormType

  ): Promise<ParticularTravelsModel> => {
    // Construir parámetros manualmente como en getPendingAssigment
    const params = new URLSearchParams();

    if (page !== null) params.append('page', String(page));
    if (page_size !== null) params.append('page_size', String(page_size));
    if (filters.id !== null) params.append('id', String(filters.id));
    if (sort !== null) params.append('sort', String(sort));
    if (dir !== null) params.append('dir', String(dir));
    if (filters.state !== false) {
      params.append('state', String(filters.state));
    } else
      params.append('state', String(ParticularTravelStatus.VIAJE_FINALIZADO));
    if (filters.status_payment !== null)
      params.append('payment_status', String(filters.status_payment));
    if (filters.clientId !== null) params.append('client_id', String(filters.clientId));
    if (filters.dateFrom !== null) params.append('dateFrom', filters.dateFrom.format());
    if (filters.dateTo !== null) params.append('dateTo', filters.dateTo.format());
    if (filters.has_required_bill !== null) params.append('has_required_bill', String(filters.has_required_bill));
    if (filters.has_send_bill !== null) params.append('has_send_bill', String(filters.has_send_bill));
    const res = await httpReservation.get(
      `private-transfer-reservations?${params.toString()}`
    );
    return {
      ...res,
      rows: res.rows.map(particularTravelBuilder.fromBackEnd)
    } as ParticularTravelsModel;
  };

  const manualPayment = async (
    travelId: number,
    payment_method_id: number,
    transaction_number: string,
    notes: string
  ) => {
    return httpClient.post(`transfer-reservations/${travelId}/payments`, {
      payment_method_id,
      transaction_number,
      notes
    });
  };

  const bill = async (
    travelIds: number[],
    number: string,
    letter: string = 'B'
  ) => {
    return httpClient.post(`private-transfer-reservations/billing`, {
      reservation_ids: travelIds,
      number: number,
      letter: letter
    });
  };

  const sendBilling = async (travelIds: number[]) => {
    return httpClient.put(`private-transfer-reservations/invoice-sent`, {
      reservation_ids: travelIds
    });
  };

  const downloadExcel = async (values: any) => {
    const params = new URLSearchParams();

    if (values.dateFrom) {
      const fromDateISO = new Date(values.dateFrom).toISOString();
      params.append('from_date', fromDateISO);
    }

    if (values.dateTo) {
      const toDateISO = new Date(values.dateTo).toISOString();
      params.append('to_date', toDateISO);
    }

    const response = await fetch(
      `${environment.export}/transfer-reservation-payments/export?${params.toString()}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        body: JSON.stringify({})
      }
    );

    if (!response.ok) {
      throw new Error('Error al descargar el informe de Excel');
    }

    return await response.json();
  };

  return {
    getAll,
    manualPayment,
    bill,
    sendBilling,
    downloadExcel
  };
};